
          import { defineNuxtPlugin } from "#imports";

          export default defineNuxtPlugin({
            name: 'sentry-client-config',
            async setup() {
              await import("/home/philip/work/general/clifton-bootcamp/sentry.client.config.ts")
            }
          });